<template>
  <div class="application relative" :style="applicationColors(application.status)">
    <slot
      name="menu"
      :approval-command="approvalCommand"
      :get-signer="getSigner"
    />
    <div class="row">
      <div class="col-sm-5 col-xs-9">
        <span>
          <span v-if="user && user.role === 'sb' && application && application.terminal && application.terminal.logo">
            <img :src="baseUrl + '/' + application.terminal.logo" alt="" class="terminal-icon">
          </span>
          <b v-if="application.status !== 'draft'">№{{ application.number }} </b>
        </span>
        <span><b v-html="applicationPeriod"></b></span>
      </div>
      <div class="col-sm-4 col-xs-10 application-status-container relative">
        <div>
          <v-popover v-if="application.status !== 'draft'" class="icon-history" trigger="hover" placement="top">
            <template v-slot:popover>
              <application-logs :logs="application.logs" />
            </template>
            <i class="fa fa-history" aria-hidden="true"></i>
          </v-popover>
          <b>{{ applicationStatus.name }}</b>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5 col-xs-12 overflow-block">
        <img v-if="Number(application.has_user_sign) === 1"
             v-tooltip="{ content: 'Заявка подписана усиленной электронной подписью' }"
             :src="baseUrl + '/img/trusted.png'"
             alt="Подписано ЭЦП"
             style="margin-left: -2px; height: 18px"
        >
        <span v-if="application.organization"
              :title="application.organization.need_attorney === '1' ? 'Руководитель по доверенности' : '' + title"
              class="application-description-visitors">
          <template v-if="application.creator_role === 'trusted_user'">
           <img v-if="application.organization.need_attorney === '1'"
                :src="baseUrl + '/img/trusted_attorney.png'"
                alt="Доверенный"
                style="margin-left: -2px; height: 18px"
           />
           <img v-else
                :src="baseUrl + '/img/trusted.png'"
                alt="Доверенный"
                style="margin-left: -2px; height: 18px"
           />
          </template>
          <template v-else>
               <img v-if="application.organization.need_attorney === '1'"
                    :src="baseUrl + '/img/non_trusted_attorney.png'"
                    alt=""
                    style="margin-left: -2px; height: 18px"
               />
          </template>
          <span
            :style="application.creator_role === 'trusted_user' ? 'margin-left: -3px' : ''"
            :title="title"
          >
            {{title}}
          </span>
        </span>
      </div>
      <div class="col-sm-4 col-xs-12 overflow-block group-comment">
        <img
          v-if="visibleAutoTypeImage"
          :src="baseUrl + '/img/icons/' + application.auto_type + '.png'"
          data-toggle='tooltip'
          class="lock-icon"
          alt=""
        >
        <span :title="getApplicationPurpose(application)">{{ getApplicationPurpose(application) }}</span>
      </div>
      <div class="col-sm-2 col-xs-12 overflow-block application-region" v-if="application.terminalRegion">
        <span :title="this.getTerminalRegionName()">{{ this.getTerminalRegionName() }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5 col-xs-12">
        <template v-if="blacklistTooltipText">
          <img v-tooltip="{ content: blacklistTooltipText }" :src="baseUrl + '/img/lock.png'" class="lock-icon" alt="lock">
        </template>
        <img class='personal-flag'
             v-if="this.personalHaveIso2"
             :src="this.personalHaveIso2 ? baseUrl + '/img/icons/' + this.personalHaveIso2 + '.svg' : ''"
             :title="this.personalTitle"
             :alt="this.personalTitle"
        >
        <template
          v-if="['notactive', 'begin', 'subdivision_no', 'sb_no', 'fsb_no', 'draft'].includes(application.status)">
          {{ declOfNum(this.visitorsPersonalsCount, ['посетитель', 'посетителя', 'посетителей']) }}
        </template>
        <template v-else>
          <span :class="{ 'text-red': this.visitorCloseCount }">
            {{ this.visitorsPersonalsCount - this.visitorCloseCount}}
            <template v-if="this.visitorCloseCount">из {{ this.visitorsPersonalsCount}}</template>
            {{ declOfNum(this.visitorsPersonalsCount, ['посетитель', 'посетителя', 'посетителей'], false) }}
          </span>
        </template>
        <span v-if="this.firstVisitorShortName">({{ this.firstVisitorShortName }})</span>
        <span class="visitors-passports-need-check-circle" v-if="application.visitorsPassportsNeedCheck">
          <label>!</label>
          <div class="form-fieldhelp-text">
            <div>Паспортные данные посетителей требуют дополнительной проверки</div>
          </div>
        </span>
      </div>
      <div class="col-sm-4 col-xs-12 overflow-block">
        <span
          v-if="application.comment"
          :title="application.comment"
          class="app-comment"
        >
          {{ application.comment }}
        </span>
      </div>
      <div class="col-sm-3 col-xs-12">
        <span v-if="haveVessel">С заходом на борт судов</span>
      </div>
    </div>

    <template v-if="haveVessel">
      <div class="row" v-if="application.vessels">
      <div v-for="(vessel, vesselKey) in application.vessels" :key="vesselKey">
          <div class="col-sm-5 col-xs-12">
            <span class="name-label">Судно: </span>
            {{ vessel.name || '' }}
          </div>
          <div class="col-sm-4 col-xs-12">
            <span class="name-label">Флаг: </span>
            <img
              v-if="vessel.vesselFlag && vessel.vesselFlag.iso2"
              :src="baseUrl + '/img/icons/' + vessel.vesselFlag.iso2 + '.svg'"
              :title="vessel.vesselFlag.full_name"
              :alt="vessel.vesselFlag.full_name"
              class='vessel-flag'
            >
            <span>{{ vessel.vesselFlag && vessel.vesselFlag.full_name ? vessel.vesselFlag.full_name : '' }}</span>
          </div>
          <div class="col-sm-3 col-xs-12 overflow-block">
            <span class="name-label">Причал: </span>
            &nbsp;
            <span :title="vessel.berth ? vessel.berth : '-'">{{ vessel.berth ? vessel.berth : '-' }}</span>
          </div>
        </div>
      </div>
    </template>

    <template v-if="documentsNumbersLength">
      <div class="row">
        <div class="col-sm-5 col-xs-12 col-md-12">
          <a
            v-b-toggle="`document-numbers${_uid}`"
            class="dashed-link"
          >
            Номера документов
          </a>
          <b-collapse :id="`document-numbers${_uid}`" class="panel-collapse">
            <div
              v-for="(document, key) in application.documentsNumbers"
              :key="key"
              style="text-wrap: avoid"
            >
              <p>
                <span style="text-decoration-line: underline">{{ document.name }}</span>
                {{ `${document.number ? '- ' + document.number : '- не указаны'}` }}
              </p>
            </div>
          </b-collapse>
        </div>
      </div>
    </template>

    <slot name="afterData"></slot>

    <application-item-cost
      :application="application"
      :archived="archived"
    />

    <sign-modal
        :application="application"
        :organization="application.organization"
        :cert-list-box-id="certListBoxId"
        :modal-id="signModalId"
        :signer="signers[Number(application.id)]"
        :sign-and-approve-command="signAndApproval"
        @show="onShowModal"
        ref="modal"
    />
  </div>
</template>

<script>
import SignModal from '@/common/components/application/form-blocks/SignModal.vue'
import axios from 'axios'
import '@/common/assets/styles/application.scss'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import loadCadesplugin from '@/common/helpers/signer/cadesplugin_api'
import ApplicationItemCost from '@/common/components/application/step-icons/ApplicationItemCost.vue'
import { ConfigMenuNames } from '@/common/enums/ConfigMenuNames'
import { PassKinds } from '@/common/enums/PassKinds'
import { VesselAccesses as VesselAccessesEnum } from '@/common/enums/VesselAccesses'
import { ClosedSigner } from '@/common/helpers/signer/close-certificates'
import ApplicationLogs from './ApplicationLogs'
import ApplicationLogListDto from '@/common/classes/dto/ApplicationLogListDto'
import moment from 'moment-timezone'
import { ApplicationStatuses } from '@/common/enums/ApplicationStatuses'

export default {
  name: 'ApplicationItem',

  components: {
    ApplicationLogs,
    ApplicationItemCost,
    SignModal
  },

  props: {
    application: { type: Object },

    applicationBlacklist: {
      type: [Object, Array],
      default: () => {}
    },

    applicationKey: Number,

    applicationPurposes: {},

    archived: { type: Number },

    needImage: {
      type: Boolean,
      default: true
    },

    pagination: {},

    statuses: {
      type: [Object, Array],
      default() {
        return {
          draft: {
            name: 'Черновик'
          },
          awaiting: {
            name: 'Ожидает подписания'
          },
          discard: {
            name: 'Отозвана'
          }
        }
      }
    }
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      signers: {}
    }
  },

  computed: {
    title() {
      let title = ''
      let organization = this.application.organization

      if (organization.name && organization.subject_id === 'individual') {
        title += 'ИП' + organization.name
      } else if (organization.short_name) {
        title += organization.short_name
      } else {
        title += organization.name
      }

      title += organization.director_name ? ', ' + organization.director_name : ''

      return title
    },

    documentsNumbersLength() {
      return this.application?.documentsNumbers?.length
    },

    visibleAutoTypeImage() {
      return this.needImage &&
        this.application.auto_type && this.application.auto_type !== 'pedestrian'
    },

    actions() {
      let actions = []
      for (const actionName in this.statusActions) {
        const action = this.statusActions[actionName]
        if (this.showActionButton(action)) {
          actions.push(action)
        }
      }

      return actions
    },

    applicationGroupPurpose() {
      return this.applicationPurposes[this.application.application_group_purpose_id]
    },

    applicationPeriod() {
      const outputFormat = 'DD.MM.YYYY'
      const inputFormat = 'YYYY-MM-DD'
      const application = this.application
      const periodTo = moment.tz(application.period_to, inputFormat, this.timezone).format(outputFormat)
      const periodOf = moment.tz(application.period_of, inputFormat, this.timezone).format(outputFormat)
      let passKind = this.application.pass_kind === 'material' ? '&nbsp;материальный' : ''

      if (application.time_type === 'permanent') {
        if (!application.period_of) {
          return 'постоянный' + passKind + '<wbr>'
        }
        if (!application.period_to) {
          return 'постоянный' + passKind + '<wbr>' + '&nbsp;с&nbsp;' + periodOf
        }
        return 'постоянный' + passKind + '<wbr>' + '&nbsp;с&nbsp;' + periodOf + '&nbsp;по&nbsp;' + periodTo
      }

      if (application.time_type === 'one') {
        if (!application.period_of) {
          return 'разовый' + passKind
        }
        if (!application.period_to) {
          return 'разовый' + passKind + '<wbr>' + '&nbsp;с&nbsp;' + periodOf
        }
        if (periodOf === periodTo) {
          return 'разовый' + passKind + '<wbr>' + '&nbsp;на&nbsp;' + periodOf
        }

        return 'разовый' + passKind + '<wbr>' + '&nbsp;с&nbsp;' + periodOf + '&nbsp;по&nbsp;' + periodTo
      }

      return passKind + '<wbr>' + '&nbsp;с&nbsp;' + periodOf + '&nbsp;по&nbsp;' + periodTo
    },

    applicationStatus() {
      let statuses = this.statuses.all_statuses
      const status = statuses.find((element) => element.id === this.application.status)

      return statuses && status ? status : ''
    },

    approveAction() {
      return this.actions.find((action) => Boolean(action.for_approval) === true)
    },

    blacklistTooltipText() {
      if (!this.applicationBlacklist || this.applicationBlacklist.length === 0 || this.application.status === ApplicationStatuses.DRAFT) {
        return false
      }

      return this.applicationBlacklist[this.application.id]
    },

    certListBoxId() {
      return `certListBox-${this.application.id}`
    },

    firstVisitorPersonals() {
      return this.application.firstVisitor.personal
    },

    firstVisitorShortName() {
      const visitor = this.firstVisitorPersonals

      const visitorShortName = visitor.fullname_last + ' ' + visitor.fullname_first.substring(0, 1) + '. ' +
          (visitor.fullname_patronymic ? (visitor.fullname_patronymic.substring(0, 1) + '.') : '')

      if (this.visitorsPersonalsCount === 1) {
        return visitorShortName
      }

      return visitorShortName + ', ...'
    },
    haveVessel() {
      return this.application.vessel_access_id !== VesselAccessesEnum.WITHOUT_VESSEL
    },

    personalHaveIso2() {
      return this.firstVisitorPersonals && this.firstVisitorPersonals.nationality && this.firstVisitorPersonals.nationality.iso2
    },

    personalTitle() {
      return this.firstVisitorPersonals ? this.firstVisitorPersonals.nationality.full_name : ''
    },

    signModalId() {
      return `modal-border-${this.application.id}`
    },

    timezone() {
      return String(this.configuration.default_timezone ?? 'Europe/Moscow')
    },

    transportCloseCount() {
      return this.application.transportsCloseCount
    },

    visitorCloseCount() {
      return this.application.visitorsCloseCount
    },

    visitorsPersonalsCount() {
      return this.application.visitorsCount
    }
  },

  methods: {
    appStatus(application, status) {
      const statusParam = this.appStatusCheck(application, status)
      const classes = {
        'profile-status-green': statusParam,
        'profile-status-red': !statusParam,
        'profile-status-close': this.visitorCloseCount !== 0 && status !== ApplicationStatuses.SUBDIVISION_YES
      }

      switch (status) {
        case ApplicationStatuses.SUBDIVISION_YES:
          return [ApplicationStatuses.AGENT_BEGIN, ApplicationStatuses.AWAITING_SIGNING, ApplicationStatuses.BEGIN, ApplicationStatuses.NOT_ACTIVE, ApplicationStatuses.SUBDIVISION_BEGIN].includes(application.status) ? {} : classes
        case ApplicationStatuses.SB_BEGIN:
          return [ApplicationStatuses.AGENT_BEGIN, ApplicationStatuses.AGENT_YES, ApplicationStatuses.AWAITING_SIGNING, ApplicationStatuses.BEGIN, ApplicationStatuses.NOT_ACTIVE, ApplicationStatuses.SUBDIVISION_BEGIN, ApplicationStatuses.SUBDIVISION_NO, ApplicationStatuses.SUBDIVISION_YES].includes(application.status) ? {} : classes
        case ApplicationStatuses.FSB_BEGIN:
          return [ApplicationStatuses.AGENT_BEGIN, ApplicationStatuses.AGENT_YES, ApplicationStatuses.AWAITING_SIGNING, ApplicationStatuses.BEGIN, ApplicationStatuses.NOT_ACTIVE, ApplicationStatuses.SB_BEGIN, ApplicationStatuses.SB_YES, ApplicationStatuses.SUBDIVISION_BEGIN, ApplicationStatuses.SUBDIVISION_NO, ApplicationStatuses.SUBDIVISION_YES].includes(application.status) ? {} : classes
        case ApplicationStatuses.FSB_NO:
          return [ApplicationStatuses.AGENT_BEGIN, ApplicationStatuses.AGENT_YES, ApplicationStatuses.AWAITING_SIGNING, ApplicationStatuses.BEGIN, ApplicationStatuses.FSB_BEGIN, ApplicationStatuses.NOT_ACTIVE, ApplicationStatuses.SB_BEGIN, ApplicationStatuses.SB_NO, ApplicationStatuses.SB_YES, ApplicationStatuses.SUBDIVISION_BEGIN, ApplicationStatuses.SUBDIVISION_NO, ApplicationStatuses.SUBDIVISION_YES].includes(application.status) ? {} : classes
        case ApplicationStatuses.KTSP:
          return [ApplicationStatuses.AGENT_BEGIN, ApplicationStatuses.AGENT_YES, ApplicationStatuses.AWAITING_SIGNING, ApplicationStatuses.BEGIN, ApplicationStatuses.FSB_BEGIN, ApplicationStatuses.FSB_NO, ApplicationStatuses.FSB_YES, ApplicationStatuses.NOT_ACTIVE, ApplicationStatuses.SB_BEGIN, ApplicationStatuses.SB_NO, ApplicationStatuses.SB_YES, ApplicationStatuses.SUBDIVISION_BEGIN, ApplicationStatuses.SUBDIVISION_NO, ApplicationStatuses.SUBDIVISION_YES].includes(application.status) ? {} : classes
        default:
          return classes
      }
    },

    appStatusCheck(application, status) {
      switch (status) {
        case ApplicationStatuses.SUBDIVISION_YES:
          return [ApplicationStatuses.AGENT_BEGIN, ApplicationStatuses.AGENT_YES, ApplicationStatuses.FSB_BEGIN, ApplicationStatuses.FSB_NO, ApplicationStatuses.FSB_YES, ApplicationStatuses.KTSP, ApplicationStatuses.SB_BEGIN, ApplicationStatuses.SB_NO, ApplicationStatuses.SB_YES, ApplicationStatuses.SUBDIVISION_YES].includes(application.status)
        case ApplicationStatuses.SB_BEGIN:
          return [ApplicationStatuses.FSB_BEGIN, ApplicationStatuses.FSB_NO, ApplicationStatuses.FSB_YES, ApplicationStatuses.KTSP, ApplicationStatuses.SB_BEGIN, ApplicationStatuses.SB_NO, ApplicationStatuses.SB_YES].includes(application.status)
        case ApplicationStatuses.FSB_BEGIN:
          return [ApplicationStatuses.FSB_BEGIN, ApplicationStatuses.FSB_NO, ApplicationStatuses.FSB_YES, ApplicationStatuses.KTSP].includes(application.status)
        case ApplicationStatuses.FSB_NO:
          return [ApplicationStatuses.FSB_YES, ApplicationStatuses.KTSP].includes(application.status)
        default:
          return [ApplicationStatuses.KTSP].includes(application.status)
      }
    },

    applicationColors(status) {
      return {
        'background-color': (this.applicationStatus?.bg_color ?? '') + ' !important',
        'border-color': (this.applicationStatus?.ln_color ?? '') + ' !important'
      }
    },

    async approvalCommand(application, statusCommandSettings, index) {
      let blockId = Math.ceil(index / this.pagination.per)
      if (blockId <= 0) {
        blockId = 1
      }
      const deleteFrom = (blockId - 1) * this.pagination.per

      const vue = this
      const filter = this.$route.query
      let success = false

      axios.post(this.baseUrl + '/application-status/update?id=' + application.id, {
        alias: statusCommandSettings.alias
      })
        .then(async function (response) {
          if (response.status === 200) {
            success = true
            if (filter && (
              filter.filter !== 'all' ||
              filter.typeFilter !== 'all' ||
              filter.subdivFilter !== 'all' ||
              filter.filterColumns !== 'all'
            )) {
              vue.$emit('splice-application', deleteFrom, blockId, application.id, index)
            } else {
              application.status = response.data.status
              application.statusActions = response.data.statusActions
              application.logs = new ApplicationLogListDto(response.data.applicationLogs)
              application.pdf = response.data.pdf
              application.comment = response.data.comment
              application.has_user_sign = response.data.has_user_sign
            }

            vue.$emit('update-statuses', response.data?.status)
          }
        })
        .catch(function (error) {
          console.log(error.response)
          alert(error.response?.data?.message || error)

          success = false
        })
        .finally(function () {
          if (success === true) {
            if (
              (Number(vue.pagination.count) - 1) % Number(vue.pagination.per) === 0 &&
              (Number(vue.pagination.active) - 1) !== 0
            ) {
              vue.pagination.active = Number(vue.pagination.active) - 1
            }
            vue.$bvModal.hide(vue.signModalId)
          }
        })
    },

    declOfNum(number, titles, showNumber = true) {
      const cases = [2, 0, 1, 1, 1, 2]

      return (showNumber ? number + ' ' : '') + titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]
    },

    async deleteApplication(application) {
      if (confirm('Удалить заявку? Она покинет нас навсегда')) {
        const response = await ApiClient.deleteApplication(application.id)
        const status = response.status

        if (status === 'success') {
          await this.$router.go(this.$router.currentRoute)
        } else {
          alert('Не удалось удалить заявку.')
        }
      }
    },

    getApplicationPurpose(application) {
      if (application.additional_purpose && application.applicationGroupPurpose) {
        return `${application.applicationGroupPurpose.name}: ${application.additional_purpose}`
      }

      if (application.applicationGroupPurpose) {
        return application.applicationGroupPurpose.name
      }

      return application.additional_purpose
    },

    getTerminalRegionName() {
      if (Number(this.configuration.use_sectors) === 1) {
        return this.application.terminal_sectors_general_name
      }

      return this.application.terminalRegion.short_name
    },

    getSigner(application, commandSettings) {
      this.$bvModal.show(this.signModalId)
      const html = document.getElementsByTagName('html')[0]
      html.classList.add('html-modal-open')

      this.$set(this.signers, application.id, new ClosedSigner({
        requestHashUrl: ApiClient.getSignerStepOneUrl(application),
        sendSignatureUrl: ApiClient.getSignerStepTwoUrl(application),
        certListBoxId: 'certListBox-' + application.id,
        statusSettings: commandSettings
      }))
      loadCadesplugin()
    },

    hide() {
      this.$refs.listmenu?.hide()
    },

    onShowModal() {
      const signer = this.signers[Number(this.application.id)]

      if (window.cadesplugin) {
        window.cadesplugin.then(function () {
          signer.requestCertificates()
        })
      }
    },

    async sendSolvoXml(appId) {
      await axios({
        method: 'post',
        url: this.baseUrl + '/api/v1/xml/solvo-xml',
        type: 'post',
        dataType: 'json',
        headers: { Authorization: `Bearer ${localStorage.accessToken}` },
        data: {
          appId
        }
      }).then(function (result) {
        console.log(result)
        if (result.data.http_code === 200 && result.data.status === 'success') {
          alert('Заявка успешно передана в Solvo.TOS')
          setTimeout(
            function () {
              window.location.reload()
            }, 1000)
        } else {
          alert('Не удалось передать в СКУД')
          console.log(result.data)
        }
      }).catch(function (xhr) {
        console.log(xhr, this.application)
      })
    },

    async signAndApproval() {
      const signer = this.signers[this.application.id]
      let result = null
      const vue = this

      try {
        result = await signer.sign()
      } catch (err) {
        console.error(err)
        alert('При подписании произошла ошибка')
        vue.$refs.modal.unsetPreload()
      }

      if (result) {
        await this.approvalCommand(this.application, signer.statusSettings, this.applicationKey)
      } else {
        alert('Ошибка подписания')
        vue.$refs.modal.unsetPreload()
      }
    },

    url(url) {
      return this.baseUrl + '/' + url
    }
  }
}
</script>
